
import { supabase } from "@/integrations/supabase/client";
import { ResourceWithFiles } from "./types";

// Process quiz files - for each resource, identify any quiz files
export async function processResources(resources: ResourceWithFiles[]): Promise<ResourceWithFiles[]> {
  return Promise.all(resources.map(async (resource) => {
    // Sort resource files by order_index
    resource.resource_files.sort((a, b) => a.order_index - b.order_index);
    
    const quizFiles = resource.resource_files.filter(file => file.file_type === 'quiz');
    
    // If we have quiz files, let's fetch questions for them
    if (quizFiles.length > 0) {
      for (const quizFile of quizFiles) {
        if (quizFile.quiz_id) {
          // Fetch questions for this quiz
          const { data: quizQuestions, error: questionsError } = await supabase
            .from('quiz_questions')
            .select('*')
            .eq('quiz_id', quizFile.quiz_id)
            .order('order_index');
            
          if (questionsError) {
            console.error('Error fetching quiz questions:', questionsError);
          } else {
            // Add questions to the quiz file
            quizFile.description = quizFile.quiz_description || quizFile.description;
            // @ts-ignore - we know this property exists from our types
            quizFile.quiz_questions = quizQuestions;
          }
        }
      }
    }
    
    return resource;
  }));
}
